import { render, staticRenderFns } from "./portBerth.vue?vue&type=template&id=7b276270"
import script from "./portBerth.vue?vue&type=script&lang=js"
export * from "./portBerth.vue?vue&type=script&lang=js"
import style0 from "./portBerth.vue?vue&type=style&index=0&id=7b276270&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports